<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">

      <div class="text-wrapper_1 flex-col" style="background-color: transparent;"><span class="text_2">积分充值</span></div>
      <div class="multi-gxy-tip">
        <strong>可添加多个公学芸账号</strong>
        <span>一个网站账号可绑定多个公学芸账号，分别管理签到服务</span>
      </div>
      <div class="section_2 flex-row justify-between">
        <div class="group_2 flex-col" v-for="product in products.slice(0, 2)" :key="product.id" 
             @click="selectProduct(product)" 
             :class="{ 'selected': selectedProduct && selectedProduct.id === product.id }">
          <div class="group_3 flex-row">
            <div class="image-text_1 flex-row">
              <div class="text-group_1 flex-col justify-between">
                <span class="text_3">{{ product.point }}</span>
                <div class="text-wrapper_2">
                  <span class="text_4">{{ product.price }}</span>
                  <span class="text_5">元</span>
                </div>
              </div>
              <div class="box_3 flex-col"><div class="group_4 flex-col"></div></div>
            </div>
            <div class="group_5 flex-col justify-between">
              <span class="text_6">{{ product.desc }}</span>

              <span class="text_7">{{ product.origin_price }}元</span>
            </div>
          </div>
          <span class="check-badge" v-if="selectedProduct && selectedProduct.id === product.id">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#00CB6A"/>
              <path d="M6.5 12.5 L10 16 L17.5 8.5" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="section_4 flex-row justify-between">
        <div class="section_5 flex-col" v-for="product in products.slice(2, 4)" :key="product.id"
             @click="selectProduct(product)" 
             :class="{ 'selected': selectedProduct && selectedProduct.id === product.id }">
          <div class="box_6 flex-row">
            <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG8a3085f9004b7547cd2cc66df7d70b59.png"
            />
            <span class="text_13">{{ product.point }}</span>
            <span class="text_14">{{ product.desc }}</span>
          </div>

          <div class="box_7 flex-row justify-between">
            <div class="text-wrapper_4">
              <span class="text_15">{{ product.price }}</span>
              <span class="text_16">元</span>
            </div>
            <span class="text_17">{{ product.origin_price }}元</span>
          </div>
          <span class="check-badge" v-if="selectedProduct && selectedProduct.id === product.id">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#00CB6A"/>
              <path d="M6.5 12.5 L10 16 L17.5 8.5" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="group_7 flex-col">
      <div class="group_8 flex-row justify-between">
        <div class="group_9 flex-col" v-for="product in products.slice(4, 6)" :key="product.id"
             @click="selectProduct(product)" 
             :class="{ 'selected': selectedProduct && selectedProduct.id === product.id }">
          <div class="group_10 flex-row">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG8a3085f9004b7547cd2cc66df7d70b59.png"
            />
            <span class="text_23">{{ product.point }}</span>
            <span class="text_24">{{ product.desc }}</span>
          </div>

          <div class="group_11 flex-row justify-between">
            <div class="text-wrapper_6">
              <span class="text_25">{{ product.price }}</span>
              <span class="text_26">元</span>
            </div>
            <span class="text_27">{{ product.origin_price }}元</span>
          </div>
          <span class="check-badge" v-if="selectedProduct && selectedProduct.id === product.id">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#00CB6A"/>
              <path d="M6.5 12.5 L10 16 L17.5 8.5" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="group_13 flex-col" v-if="products.length > 6"
           @click="selectProduct(products[6])" 
           :class="{ 'selected': selectedProduct && selectedProduct.id === products[6].id }">
        <div class="block_4 flex-row">
          <img
            class="thumbnail_7"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG8a3085f9004b7547cd2cc66df7d70b59.png"
          />
          <span class="text_33">{{ products[6].point }}</span>
          <span class="text_34">{{ products[6].desc }}</span>
        </div>

        <div class="block_5 flex-row justify-between">
          <div class="text-wrapper_8">
            <span class="text_35">{{ products[6].price }}</span>
            <span class="text_36">元</span>
          </div>
          <span class="text_37">{{ products[6].origin_price }}元</span>
        </div>
        <span class="check-badge" v-if="selectedProduct && selectedProduct.id === products[6].id">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#00CB6A"/>
            <path d="M6.5 12.5 L10 16 L17.5 8.5" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>
      <span class="text_38">支付方式</span>
      <div class="group_14 flex-col justify-between">
        <div class="box_8 flex-row" @click="selectPayType('wechat')" 
             :class="{ 'selected': selectedPayType === 'wechat' }">
          <div class="image-text_3 flex-row justify-between">
            <div class="block_6 flex-col">
              <div class="block_7 flex-col" v-if="selectedPayType === 'wechat'"></div>
            </div>
            <span class="text-group_4">微信支付</span>
          </div>
          <!-- <img
            class="thumbnail_8"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGf22d8215c0a75dc17f120a22058127a2.png"
          /> -->
          <!-- <div class="group_15 flex-col" v-if="selectedPayType === 'wechat'"></div>
          <div class="group_16 flex-col"></div> -->
          <span class="check-badge" v-if="selectedPayType === 'wechat'">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#00CB6A"/>
              <path d="M6.5 12.5 L10 16 L17.5 8.5" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="text-wrapper_9 flex-col" @click="submitPayment">
        <span class="text_39">{{ loading ? '处理中...' : '提交' }}</span>
      </div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>
<script>
import axios from 'axios'
import { Toast } from 'vant'
import BottomNavigation from '@/components/BottomNavigation.vue'
import { API_ENDPOINTS } from '@/config/api'

export default {
  components: {
    BottomNavigation
  },
  data() {
    return {
      products: [],
      userInfo: {},
      selectedProduct: null,
      selectedPayType: 'wechat',
      loading: false
    };
  },
  async mounted() {
    await this.getProducts();
    await this.getUserInfo();
  },
  methods: {
    showToast(message) {
      Toast(message);
    },
    // 获取商品列表
    async getProducts() {
      try {
        const res = await axios.get(API_ENDPOINTS.PAY.GET_PRODUCT);
        
        if (res.data.code === 0) {
          this.products = res.data.data || [];
        } else {
          this.showToast(res.data.message || '获取商品列表失败');
        }
      } catch (error) {
        console.error('获取商品列表失败:', error);
        this.showToast('获取商品列表失败，请重试');
      }
    },
    // 获取用户信息
    async getUserInfo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.get(API_ENDPOINTS.USER.INFO, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          this.userInfo = res.data.data;
        } else {
          this.showToast(res.data.message || '获取用户信息失败');
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        }
      }
    },
    selectProduct(product) {
      this.selectedProduct = product;
    },
    selectPayType(payType) {
      this.selectedPayType = payType;
    },
    async submitPayment() {
      if (this.loading) return;
      
      if (!this.selectedProduct) {
        this.showToast('请选择要购买的商品');
        return;
      }
      
      if (!this.selectedPayType) {
        this.showToast('请选择支付方式');
        return;
      }
      
      this.loading = true;
      await this.createPayOrder(this.selectedPayType);
      this.loading = false;
    },
    async createPayOrder(payType = 'wechat') {
      if (!this.selectedProduct) {
        this.showToast('请选择要购买的商品');
        return;
      }
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.post(API_ENDPOINTS.PAY.HUPI_PAY, {
          product_id: this.selectedProduct.id,
          pay_type: payType
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          const payUrl = res.data.data.url;
          const orderId = res.data.data.order_id;

          // 检测设备类型，苹果设备使用直接跳转，其他设备使用弹窗
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

          if (isIOS || isSafari) {
            // 苹果设备或Safari浏览器直接跳转
            window.location.href = payUrl;
          } else {
            // 其他设备使用弹窗
            window.open(payUrl, '_blank');
            this.pollPaymentStatus(orderId);
          }
        } else {
          this.showToast(res.data.message || '创建支付订单失败');
        }
      } catch (error) {
        console.error('创建支付订单失败:', error);
        this.showToast('创建支付订单失败，请重试');
      }
    },
    async pollPaymentStatus(orderId) {
      const maxAttempts = 30;
      let attempts = 0;
      
      const poll = async () => {
        if (attempts >= maxAttempts) {
          this.showToast('支付超时，请手动刷新页面查看结果');
          return;
        }
        
        try {
          const token = localStorage.getItem('token');
          const res = await axios.get(`${API_ENDPOINTS.PAY.HUPI_PAY_QUERY}?order_id=${orderId}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (res.data.code === 0 && res.data.message === '支付成功') {
            this.showToast('支付成功！');
            await this.getUserInfo();
            return;
          } else if (res.data.message === '已取消') {
            this.showToast('支付已取消');
            return;
          }
          
          attempts++;
          setTimeout(poll, 2000);
        } catch (error) {
          console.error('查询支付状态失败:', error);
          attempts++;
          setTimeout(poll, 2000);
        }
      };

      poll();
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.selected {
  border: 2px solid #1989fa !important;
  background-color: #f0f9ff !important;
}

.group_2,
.section_5,
.group_9,
.group_13 {
  position: relative;
}

.box_8.selected,
.box_9.selected {
  background-color: #e8f4fd !important;
  border: 2px solid #1989fa !important;
}

.box_8,
.box_9 {
  position: relative;
}

.thumbnail_9 {
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
}

.text-wrapper_9 {
  cursor: pointer;
  transition: all 0.2s ease;
}

.text-wrapper_9:hover {
  transform: scale(1.05);
}

.text-wrapper_9:active {
  transform: scale(0.98);
}

/* 可视化勾选徽标（替代圆点） */
.check-badge {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 22px;
  height: 22px;
  display: inline-block;
}

/* 支付方式的勾选徽标位置 */
.box_8 .check-badge,
.box_9 .check-badge {
  right: 8px;
  top: 8px;
  bottom: auto;
}

.check-badge svg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
<style>
.multi-gxy-tip {
  margin: 10px 16px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(0, 203, 106, 0.10);
  color: #152C07;
  display: flex;
  flex-direction: column;
  gap: 3px;
  line-height: 1.45;
}
.multi-gxy-tip strong { font-size: 14px; color: #00a85a; }
.multi-gxy-tip span { font-size: 12px; color: #58705d; }
</style>
